import DashboardBPCentroCustoPie from "./relatorios-meubp/DashboardBPCentroCustoPie";
import DashboardBPConsolidado from "./relatorios-meubp/DashboardBPConsolidado";
import DashboardBPContaPie from "./relatorios-meubp/DashboardBPContaPie";
import DashboardBPFilial from "./relatorios-meubp/DashboardBPFilial";

function MeuBPDashboard({ data, loading}) {

    return (
        <div className="border-bottom border-border py-4 mb-2">
            <div className="flex flex-wrap sm:flex-wrap justify-between ">
                <DashboardBPConsolidado consolidadoAnual={data.consolidadoAnual} loading={loading} />
                <DashboardBPContaPie dados={data.totaisPorConta} loading={loading} />
                <DashboardBPCentroCustoPie dados={data.totaisPorCentro} loading={loading} />
                <DashboardBPFilial dados={data.totaisPorFilial} loading={loading} />
            </div>
        </div>
    )
}

export default MeuBPDashboard;